import { COMMISSIONS_WALLETS } from '../constants/business'
import { transferToken } from '../handlers/walletActions/wallet'
import { PlugToken } from '../interfaces/common'
import { logger } from '../logger'

const getCommissionWallet = () => {
  const randomIndex = Math.floor(Math.random() * COMMISSIONS_WALLETS.length)

  return COMMISSIONS_WALLETS[randomIndex]
}

export const transferPlugCommission = async (
  commission: number,
  token: PlugToken,
  memo?: number
) => {
  if (commission <= (token.fee || 0)) return

  try {
    await transferToken({
      standard: token.standard,
      tokenCanisterId: token.address,
      receiver: {
        address: getCommissionWallet(),
      },
      amount: (commission - (token.fee || 0)).toString(),
      memo,
      tokenId: token.id,
      chain: token.chain,
    })
  } catch (e) {
    logger.error('Failed to transfer Plug commission', { originalError: e, token, memo })
  }
}
